<template>
  <div>
    <nav-breadcrumb :menu="[{label: '提款申请'}, {label: detailData.fi__applicationStatus == 'Pending Approval' ? '审核提款' : '提款详情'}]"/>
    <financing-applying-detail-component
      :financingDetailData="detailData"
      :repayment-plan-list="repaymentPlanList"
    />
    <!--<financing-applying-form-component v-model="detailData">-->

    <!--</financing-applying-form-component>-->
    <form-build
      v-if="detailData.fi__applicationStatus == 'Pending Approval'"
      form-name="approvalForm"
      :form-buttons="approvalFormButtons"
      :form-columns-group="approvalFormColumnsGroups"
      :form-rules="approvalFormRules"
      :form-data="approvalForm"
    ></form-build>
    <el-row>
      <button-back></button-back>
    </el-row>
  </div>
</template>

<script>
  import FinancingApplyingDetailComponent from '../../components/FinancingApplyingDetailComponent'
  import FormBuild from '../../../components/FormBuild'
  import ButtonBack from '../../../components/ButtonBack'
  import xhr from '../../../utils/xhr'
  import moment from 'moment'
  import FinancingApplyingFormComponent from "../../components/FinancingApplyingFormComponent";

  export default {
    name: "FinancingApplyingDetail",
    data() {
      return {
        tabName: 'FinancingSummary',
        applicationId: this.$route.query['fi.applicationId'],
        detailData: {
          invoices:[],
          files:[],
          detail: []
        },
        approvalForm:{
          "fi__applicationId": this.$route.query['fi.applicationId'],
          "a__approvingStatus": "Rejected",
          "a__remarks": ""
        },
        approvalFormRules:{},
        approvalFormColumnsGroups:[
          {
            label: '融资审核',
            columns: [
              {
                label: '审核意见',
                field: 'a__remarks',
                component: 'el-input',
                type: 'textarea',
                span: 24
              }
            ]
          }
        ],
        approvalFormButtons: [
          {
            label: '审核通过',
            type: 'primary',
            clickHandler: ($refs)=>{
              this.updateCustomerApplyingPledgeFinancing($refs, 'Approved')
            }
          },
          {
            label: '拒绝',
            // type: 'primary',
            clickHandler: ($refs)=>{
              this.updateCustomerApplyingPledgeFinancing($refs, 'Rejected')
            }
          }
        ],
        repaymentPlanList: {
          data:[],
          count: 0
        }
      }
    },
    mounted() {
      this.getCustomerApplyingFinancingDetail()
    },
    components: {
      FinancingApplyingFormComponent,
      ButtonBack,
      FinancingApplyingDetailComponent,
      FormBuild
    },
    computed: {
      filterOption: function () {
        return this.$route.query
      },
      detailInvoicesData: function() {
        return {
          data: this.detailData.invoices
        }
      },
      detailFilesData: function () {
        return {
          data: this.detailData.files,

        }
      }
    },
    methods: {
      getCustomerApplyingFinancingDetail: function (applicationId = this.applicationId) {
        xhr.getCustomerApplyingFinancingDetail(
          {
            'fi.applicationId' : applicationId
          },
          res=>{
            try{
              if(res.data.status == 'success') {
                this.detailData = res.data.data
              }
            }catch(e){}
          })
      },
      updateCustomerApplyingPledgeFinancing: function ($refs, approvingStatus) {
        this.approvalForm.a__approvingStatus = approvingStatus

        $refs.validate(valid=>{
          if(approvingStatus == 'Rejected' || valid) {
            xhr.updateCustomerApplyingFinancing(
              Object.assign({}, this.approvalForm, this.detailData),
              res=> {
                try {
                  if(res.data.status == 'success') {
                    this.getCustomerApplyingFinancingDetail()
                  }
                }catch (e) {

                }
              }
            )
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/FinancingApplyingDetail.vue